import React from 'react';

const markup = String.raw`<div class="card inline-style-26">
<div class="card-head"><p class="card-title">Upcoming deliveries</p></div>
<table><tr><th>PO number</th><th>Item</th><th>Qty</th><th>Expected</th></tr>
<tbody id="vendUpcomingBody"></tbody>
</table>
</div>`;

export default function UpcomingDeliveriesCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
